import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./centralIpdType.css";
import { CentralIpdTypeModal } from "./CentralIpdTypeModal";
import { updateCentralAppointmentStatus, fetchCentralIpdTypeData } from "../../../_services/centralServices/centralCancelAppointment.service";
import { useDispatch, useSelector } from 'react-redux';
import { getTokenFromLocal } from '../../../_helpers/handleResponseMiddleware';
import { toast } from 'react-toastify';
import { centralReportingDataActions } from "../../../_actions";


export const CentralIpdType = () => {
    const dispatch = useDispatch();
    const { hospitalId } = useParams();
    const reportingData = useSelector(state => state.centralReportingData);
    const userDetails = useSelector(state => state.authentication.user);
    // Find active patient data from reportingData

    const activePatientData = reportingData?.reportingData?.data?.find(
        item => item.appointment_id === reportingData?.activePatientId || item._id === reportingData?.activePatientId
    );

    // Extract ipdType from active patient data
    const initialIpdType = activePatientData?.ipdType || "";

    const [ipdType, setIpdType] = useState(initialIpdType);
    const [showModal, setShowModal] = useState(false);
    const [shouldPreserveIpdType, setShouldPreserveIpdType] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);
    const [ipdOptions, setIpdOptions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchCentralIpdTypeData();
                setIpdOptions(response?.data?.ipdTypeFilters || []);
            } catch (error) {
                console.error('Error fetching IPD type data:', error);
            }
        };
        fetchData();
    }, []);

    const getOptionData = () => {
        const patientDisease = activePatientData?.category || activePatientData?.Disease;
        const matchedCategory = ipdOptions.find(option => option.Disease === patientDisease);
        return matchedCategory ? matchedCategory.ipdSubType : [];
    };



    // Ensure dropdown updates when reportingData changes
    useEffect(() => {
        if (initialIpdType) {
            setIpdType(initialIpdType);
        }
    }, [initialIpdType]);

    const handleSubmit = async (selectedIpdType) => {
        const user = userDetails || getTokenFromLocal();
        const appId = reportingData?.activePatientId;
        // const leadId = activePatientData?.lead_id;

        if (!appId || !user?.userId) {
            toast.error('Required appointment data is missing');
            return;
        }

        try {
            const payload = {
                appId: appId,
                updateObj: {
                    ipdType: selectedIpdType,
                    ipdTypeChangeReason: {
                        actionTakenBy: user?.userId,
                        actionTakenByUser: user?.username || user?.name,
                        dateTimeIso: new Date().toISOString(),
                        source: "hosChatApp",
                    }
                },
                // leadId: leadId
            };

            const response = await updateCentralAppointmentStatus(payload);
            if (response?.message === 'Success') {
                toast.success('IPD Type updated successfully');
                dispatch(centralReportingDataActions.getCentralReportingData({ "search_query": appId }));
            } else {
                toast.error('Failed to update IPD Type');
            }
        } catch (error) {
            console.error('Error updating appointment:', error);
            toast.error(error?.message || 'Failed to update IPD Type');
        }
    };

    const handleChange = (event) => {
        const value = event.target.value;
        setIpdType(value);
        if (value) {
            if (value === "Medical Management") {
                setShowModal(true);
            } else {
                handleSubmit(value);
            }
        }
    };

    const handleModalClose = () => {
        setShowModal(false);
        setIsViewMode(false);

        if (!shouldPreserveIpdType) {
            setIpdType(initialIpdType);
        }

        setShouldPreserveIpdType(false);
    };

    const handleViewClick = () => {
        setShouldPreserveIpdType(true);
        setShowModal(true);
        setIsViewMode(true);
    };

    return (
        <>
            <div className="containerClass">
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">IPD Type</span>
                    <span className="textReadOnlyValue">
                        <select
                            value={ipdType}
                            onChange={handleChange}
                            className="appointmentDropdown"
                            aria-label="IPD Type"
                        >
                            <option value="">Select IPD Type</option>
                            {getOptionData().map((subType, index) => (
                                <option key={index} value={subType}>
                                    {subType}
                                </option>
                            ))}
                        </select>
                    </span>
                </div>
                {showModal && (
                    <CentralIpdTypeModal
                        onClose={handleModalClose}
                        hospitalId={hospitalId}
                        selectedIpdType={ipdType}
                        isViewMode={isViewMode}
                        reportingData={reportingData}
                        handleViewClick={handleViewClick}
                    />
                )}
            </div>
            {ipdType === "Medical Management" && (
                <span
                    className="viewLink"
                    onClick={handleViewClick}
                >
                    View/Modified Reasons
                </span>
            )}
        </>
    );
};
